import { Avatar, Box, Spinner, useImage, Image } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getOriginIconUrl } from '../../../utils/source'

interface Props {
  typeId: number
  baseUrl: string
  loadingSources: boolean
}

const ExternalStorageIcon = ({
  typeId,
  baseUrl,
  loadingSources,
}: Props): ReactElement => {
  const imageUrl = useMemo(
    () =>
      getOriginIconUrl({
        typeId: Number(typeId),
        baseUrl: baseUrl || '',
      }),
    [typeId, baseUrl],
  )

  const imageStatus = useImage({ src: imageUrl })

  if (
    loadingSources ||
    imageStatus === 'pending' ||
    imageStatus === 'loading'
  ) {
    return (
      <Box height="12" width="12" p="3">
        <Spinner bgSize="6" />
      </Box>
    )
  }

  return (
    <Avatar size="md" background="transparent" borderRadius="0px">
      {imageStatus === 'loaded' ? (
        <Image src={imageUrl} />
      ) : (
        <Image src="https://ik.imagekit.io/demo/img/icons8-server-64_sibZOIGTb.png" />
      )}
    </Avatar>
  )
}

export default ExternalStorageIcon
